import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../../shared/services/settings/settings.service';
import { WindowRef } from '../../shared/services/window/window.ref';
import * as _ from 'lodash';
import { Header, ExternalLink } from './header.model';
import { HeaderService } from './header.service';
import { takeUntil } from 'rxjs/operators';
import { BaseObserver } from '../../shared/baseobserver';
import { FeatureToggleService } from '../../shared/services/feature-toggle/feature-toggle.service';
import urlJoin from 'url-join';

@Component({
  selector: 'ssg-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less']
})
export class HeaderComponent extends BaseObserver implements OnInit {

  public header: Header;

  constructor(
    private readonly _settingsService: SettingsService,
    private readonly _window: WindowRef,
    private readonly _headerService: HeaderService,
    private readonly productConfigService: FeatureToggleService,
  ) {
    super();
  }

  get showBack(): boolean {
    return !!this.getBackLink(this.header);
  }

  get showButtonsAndCrumb(): boolean {
    return !this.productConfigService.isFeatureEnabled('enableCUIUnifiedNavigation');
  }

  ngOnInit() {
    this._headerService.header
      .pipe(takeUntil(this.destroy$))
      .subscribe(header => {
        this.header = header;
      });
  }

  launchHelp() {
    this.openHelp(this.header.ultiProHelpPageName, this._settingsService.ultiproCountry, this._settingsService.ultiproUrl);
  }

  goBack() {
    const backLink = this.getBackLink(this.header);
    this.navTo(backLink);
  }

  navTo(link: string | ExternalLink) {
    if (typeof link === 'string') {
      this._headerService.navigate([{ outlets: { eepay: link }}]);
    } else {
      (link as ExternalLink)();
    }
  }

  private openHelp(headerPage: string, ultiproCountry: string, ultiproUrl: string) {
    const helpWidth = 976;
    const helpHeight = 720;
    const xcoord = window.screenX + (helpWidth / 2);
    const ycoord = window.screenY + 50;
    const windowParams = 'left=' + xcoord + ',top=' + ycoord + ',toolbars=no,height=' + helpHeight + 'px,width=' +
      helpWidth + 'px,resizable=yes,scrollbars=auto';

    let paramString = '?USParams=PK=EPAY';
    paramString += '!pageName=paymentservicesgw.aspx';
    paramString += '!page=' + encodeURI(headerPage);
    paramString += `!country=${ultiproCountry}`;

    const pageName = urlJoin(ultiproUrl, '/pages/utility/Help.aspx', paramString);
    this._window.nativeWindow.open(pageName, 'help-window', windowParams);
  }

  private getBackLink(header: Header): string | ExternalLink {
    if (header.customBackLink) {
      return header.customBackLink;
    } else if ((header.breadcrumbTrail || []).length > 0) {
      return header.breadcrumbTrail[header.breadcrumbTrail.length - 1].link;
    }
    return null;
  }
}
